/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import coating_division from "../../assets/images/services/coating-division.png";

const stats = [{ label: "Warranty", value: "20 Years" }];

export default function Example() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // reveal the section heading and title
      sr.reveal(
        "#coating .font-united_sans_sm, #coating .font-united_sans_lg",
        {
          origin: "left",
          distance: "20px",
          duration: 600,
          interval: 150,
        }
      );

      // reveal the descriptive paragraph
      sr.reveal("#coating .mt-6.text-xl\\/8", {
        origin: "bottom",
        distance: "20px",
        duration: 600,
        delay: 200,
      });

      // reveal the image
      sr.reveal("#coating img", {
        origin: "right",
        distance: "40px",
        duration: 800,
        delay: 400,
      });

      // reveal the stats
      sr.reveal("#coating dl div", {
        origin: "bottom",
        distance: "20px",
        duration: 600,
        interval: 150,
        delay: 600,
      });
    }
  }, []);

  return (
    <div
      id="coating"
      className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0"
    >
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <svg
          aria-hidden="true"
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
        >
          <defs>
            <pattern
              x="50%"
              y={-1}
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect
            fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)"
            width="100%"
            height="100%"
            strokeWidth={0}
          />
        </svg>
      </div>
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="font-united_sans_sm text-base/7 font-semibold text-[#D2B48C]">
                PROTECT YOUR ROOF
              </p>
              <h1 className="font-united_sans_lg mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                Coating Division
              </h1>
              <p className="mt-6 text-xl/8 text-gray-700">
                Our Coating Division specializes in high-performance roof
                coatings that extend the lifespan of your roof while enhancing
                durability and energy efficiency. We use Eterna-Sil Premium
                Silicone Coatings, which form a direct bond to the roof surface,
                providing exceptional adhesion and long-term waterproofing
                protection. With this system, you’ll never have to tear your
                roof off again—eliminating the need for costly replacements and
                landfill waste.
              </p>
            </div>
          </div>
        </div>
        <div className="-ml-12 -mt-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            alt=""
            src={coating_division}
            className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base/7 text-gray-700 lg:max-w-lg">
              <p>
                Here’s how it works: Apply the Eterna-Sil coating system and
                receive a 20-year warranty. After 20 years, we return to apply a
                maintenance coat, renewing your warranty for another 20 years.
                This cycle can continue indefinitely, keeping your roof in peak
                condition without ever having to remove or dispose of old
                roofing materials. It’s a sustainable, cost-effective solution
                that not only protects your investment but also reduces
                environmental impact by keeping roofing materials out of
                landfills.
              </p>
              <dl className="mt-10 grid grid-cols-2 gap-8 border-t border-gray-900/10 pt-10 sm:grid-cols-3">
                {stats.map((stat, statIdx) => (
                  <div key={statIdx}>
                    <dt className="text-sm/6 font-semibold text-gray-600">
                      {stat.label}
                    </dt>
                    <dd className="mt-2 text-3xl/10 font-bold tracking-tight text-gray-900">
                      {stat.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
